export default __webpack_public_path__ + "static/336-ba43d36afc61f5def562c7959c127b10.gif";